/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */


/*@ngInject*/
export default function AssignDeviceController($rootScope, $mdDialog, $stateParams, types, multicastGroupService, entityTableConfiguration, importExport) {

    var vm = this;

    vm.$onInit = function () {
        vm.entityTableConfiguration = entityTableConfiguration;
        vm.translations = types.entityTypeTranslations[vm.entityType];
        vm.multicastGroupId = $stateParams.multicastGroupId;
        vm.isBulkDevices = false;
        vm.assign = assign;
        vm.cancel = cancel;
        vm.importFromCsv = importFromCsv;
        vm.downloadExampleFile = downloadExampleFile;

        vm.loading = function () {
            return $rootScope.loading;
        };
    };

    function cancel() {
        $mdDialog.cancel();
    }

    function assign() {
        return vm.isBulkDevices ? assignBulkDevicesToMulticastGroup() : assignDeviceToMulticastGroup();
    }

    function assignDeviceToMulticastGroup() {
        multicastGroupService.addDevicesToMulticastGroup(vm.multicastGroupId, {devicesEuis: [ vm.assignDeviceEUI ] }).then(() => {
            entityTableConfiguration.reloadEntities();
            $mdDialog.hide();
        })
    }

    function importFromCsv($event) {
        importExport.uploadFile($event, [types.fileType.CSV],
            'bulk-provisioning.import-data', 'bulk-provisioning.result-file').then(
            (csvData) => {
                vm.fileContent = csvData;
                vm.headerColumns = vm.fileContent.split(/[\r\n]+/)[0].split(',');
            },
            function fileSelectCanceled() {
            });
    }

    function generateExampleFile() {
        const columnHeaders = [types.bulk_provisioning.device_dev_eui_column];
        let csvData = columnHeaders.join(',') + '\n';
        const devEuiExample = "647FDA000000000";
        for (let i = 1; i <= 5; i++) {
            csvData +=  devEuiExample + i + '\n';
        }
        return csvData;
    }

    function downloadExampleFile() {
        const fileContent = generateExampleFile();
        importExport.downloadFile(fileContent, 'Device_Bulk_Assigning_sample', types.fileType.CSV);
    }

    function getFieldValue(headerColumns, rowValues, columnName) {
        var deviceEuiColumnIdx = headerColumns.indexOf(columnName);
        return rowValues[deviceEuiColumnIdx];
    }

    function assignBulkDevicesToMulticastGroup() {
        var devicesEUIs = [];
        var rows = vm.fileContent.split(/\r?\n/);
        var rowValues = [];
        for (var i = 1; i < rows.length; i++) {
            rowValues = rows[i].split(',');
            if (rowValues.length === 1 && !rowValues[0].trim().length) {
                // Do not show a warning if a processed file's line is empty, continue to process the next line.
            } else {
                var deviceEui = getFieldValue(vm.headerColumns, rowValues, types.bulk_provisioning.device_dev_eui_column);
                devicesEUIs.push(deviceEui);
            }
        }

        multicastGroupService.addDevicesToMulticastGroup(vm.multicastGroupId, {devicesEuis: devicesEUIs }).then(() => {
            entityTableConfiguration.reloadEntities();
            $mdDialog.hide();
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/device/assigning/assign-device.controller.js